import type { FaireProductEntity } from "../../entity_types/product";

export const p_5duth2u4xw: FaireProductEntity = {
  token: "p_5duth2u4xw",
  type: "product",
  name: "Kamara Striped Alna Button Up Midi Dress",
  brandToken: "b_eiw5tz7npc",
  brandName: "Sugarlips",
  imageUrl:
    "https://cdn.faire.com/fastly/8d3201efe9bba67702f44dc91986f30f4f3f977220c7964fe9091b56c3c98817.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93e7c16231c047c17c5165f13ca767edbef148e2ca4d0c6d90cee4b0518ea6b5.jpeg",
    "https://cdn.faire.com/fastly/eb174145527afc9ec4ed8154d68341674dd3c3c70d144c97cd14692f8d55848b.jpeg",
    "https://cdn.faire.com/fastly/8db49a04204612484aab4c6bbe6349707f4bc5e8148ea7f9fc5f6834c22e9b36.jpeg",
    "https://cdn.faire.com/fastly/d1c7aba566532a3d5a9af08fb2b89f0d2cb9930b446560580da0b7fd5205a6d1.jpeg",
    "https://cdn.faire.com/fastly/5456002d0610f9147de3e7613d373fbf70e626a8cb66133013dca9d24487d18a.jpeg",
    "https://cdn.faire.com/fastly/be68fa9310f25ee09b4a71208ff592b923e15b08c7a462d66430bc2f1a957c3f.jpeg",
  ],
  priceDollars: 238,
  description:
    'Forget solids, make a statement! This pretty dress has cute stripes  and is designed with short ruffle sleeves, a button front, adjustable waist tie, and tiered hem for effortless charm. Perfect for any occasion, just add on your heels or sandals. \n\n- Pockets\n- Midi\n- Striped\n- Ruffle short sleeves\n- Color: Marshmallow\n\nSize + Fit \n- Model is 5\'9 and wearing size XS\n- Measurements taken from size S \n- Chest: 20 1/2"\n- Length: 55"',
  tags: [],
  msrpDollars: 577.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:53.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
